<template>
    <div class="content">
        <div class="left-sidebar" id="left-sidebar">
            <el-menu default-active="1-1" class="el-menu-vertical-demo">
                <el-submenu v-for="item in items" :index="item.index" :key="item.index">
                    <template slot="title">
                        <i class="el-icon-menu"></i>{{item.name}}</template>
                    <el-menu-item v-for="option in item.options" :index="option.index" :key="option.index">
                        <router-link :to="option.link">{{option.name}}</router-link>
                    </el-menu-item>
                </el-submenu>
            </el-menu>
        </div>
        <router-view class="right-iframe" id="right-iframe"></router-view>
    </div>
</template>

<script>
export default {
    data() {
        return {
            items: [
                {
                    name: '小秘书',
                    index: '1',
                    options: [
                        { index: '1-1', link: '/message/msgPush', name: '消息推送' },
                        { index: '1-2', link: '/message/msgManage', name: '消息管理' }
                    ]
                }
            ]
        }
    }
}
</script>


// WEBPACK FOOTER //
// index.vue?ea87d5dc